import { Alert, Button, CircularProgress } from "@mui/material";
import useOTPStepData from "./otpStepData";
import { Icon, OTPInput } from "@components/index";
import "./index.scss";

const OTPStep = ({
  formData,
  otpError,
  loading,
  handleChange,
  handleSubmit,
  handleResend,
  handleBack,
}) => {
  const { canResend, timer, handleResendWithTimer } = useOTPStepData({
    handleResend,
  });

  // Simple OTP change handler without auto-verification
  const handleOTPChange = (value) => {
    handleChange({ target: { name: "otp", value } });
  };

  return (
    <form onSubmit={handleSubmit} className="otp-form">
      <div className="otp-form-subTitle">
        Sent on {formData?.email}
        <Icon
          iconName="edit"
          height={16}
          className="otp-form-edit-icon"
          onClick={handleBack}
        />
      </div>

      {/* Updated OTP Input with 6 digits for auto-verification */}
      <OTPInput
        length={6}
        value={formData?.otp}
        onChange={handleOTPChange}
        error={!!otpError}
        disabled={loading}
        className="otp-input"
      />

      <Button
        type="submit"
        fullWidth
        variant="contained"
        size="large"
        className="login-button"
        disabled={loading || formData?.otp?.length !== 6}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Verify OTP"
        )}
      </Button>

      {otpError && (
        <Alert severity="error" className="login-alert">
          {otpError}
        </Alert>
      )}

      <div className="button-wrapper">
        <Button
          variant="text"
          size="small"
          className="resend-button inline-button"
          onClick={handleResendWithTimer}
          disabled={loading || !canResend}
        >
          {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
        </Button>

        <Button
          variant="text"
          size="small"
          className="back-button inline-button"
          onClick={handleBack}
          disabled={loading}
        >
          Back to Login
        </Button>
      </div>
    </form>
  );
};

export default OTPStep;
